// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".notes .briq-panel {\n  width: 600px;\n  margin-right: 32px;\n}\n", ""]);
// Exports
module.exports = exports;
